module.exports = __webpack_public_path__ + "static/img/zx.c1107b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/zx.jpg
// module id = c5xL
// module chunks = 1